__turbopack_context__.v({
  "content": "Typography-module-scss-module__GjVo2q__content",
  "display": "Typography-module-scss-module__GjVo2q__display",
  "headline": "Typography-module-scss-module__GjVo2q__headline",
  "title": "Typography-module-scss-module__GjVo2q__title",
});
